import type { CopyPhase } from '~/components/page/Automation/v2/state/interactions';

/**
 * Valid forward transitions between copy-action phases.
 * Anything not listed here is a programming error and will throw at runtime.
 */
const VALID_COPY_TRANSITIONS: Partial<Record<CopyPhase, CopyPhase>> = {
  selecting: 'pasting',
  pasting: 'choosingPathToConnect',
};

/**
 * Asserts that transitioning from `from` to `to` is a legal copy-phase
 * transition. Throws if the transition is unexpected so bugs surface early
 * rather than causing silent mis-pastes.
 */
const assertCopyPhaseTransition = (from: CopyPhase, to: CopyPhase): void => {
  if (VALID_COPY_TRANSITIONS[from] !== to) {
    throw new Error(
      `Invalid copy-phase transition: "${from}" → "${to}". Expected "${VALID_COPY_TRANSITIONS[from] ?? 'none'}"`,
    );
  }
};

export default assertCopyPhaseTransition;
